import * as i18n from 'i18next'
import { WidgetFab } from './WidgetFab'
import resources from '../../utils/i18n'
import { withProfiler } from '@sentry/react'
import { WidgetContent } from './WidgetContent'
import { MemoryRouter } from 'react-router-dom'
import { initReactI18next } from 'react-i18next'
import { ProfileProvider } from '../../utils/Profile'
import detector from 'i18next-browser-languagedetector'
import { RealtimeUpdatesWorker } from './RealtimeWorker'
import intervalPlural from 'i18next-intervalplural-postprocessor'
import { WidgetOpenManager, WidgetRootManager } from '../../utils'

i18n
  .use(detector)
  .use(initReactI18next)
  .use(intervalPlural)
  .init({
    ns: ['common'],
    fallbackLng: 'en',
    initImmediate: false,
    resources,
  })

type Props = {
  left?: boolean
  responsive: boolean | 'hide'
  responsiveBreakpoint: number
  root: HTMLDivElement | ShadowRoot
  openCallback: (open: boolean) => void
}

export const FiresquadWidget = withProfiler(
  ({ root, left, responsive, responsiveBreakpoint, openCallback }: Props) => {
    return (
      <WidgetRootManager root={root}>
        <WidgetOpenManager
          responsive={responsive}
          responsiveBreakpoint={responsiveBreakpoint}
          openCallback={openCallback}
        >
          <MemoryRouter>
            <ProfileProvider>
              <RealtimeUpdatesWorker />
              <WidgetContent left={left} />
              <WidgetFab left={left} />
            </ProfileProvider>
          </MemoryRouter>
        </WidgetOpenManager>
      </WidgetRootManager>
    )
  }
)
